import { FC, useCallback, useEffect, useState } from 'react';
import axiosInstance from 'utils/axios';
import { URLS } from 'utils/constants/urls';
import { createDropdownData } from 'utils/validators/HelperFunctions';
import TaskRecordsList from './MyTasklist';

const TaskList: FC = () => {
  const [tabValue, setTabValue] = useState(0);
  const [assignees, setAssignees] = useState<any[]>([]);

  const getMasterData = useCallback(async () => {
    try {
      const { data } = await axiosInstance.get(URLS.getReportingUsers);
      setAssignees(createDropdownData(data, ['id', 'name']));
    } catch (error: any) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getMasterData();
  }, [getMasterData]);

  return <TaskRecordsList tabValue={tabValue} onTabChange={setTabValue} assignees={assignees} />;
};

export default TaskList;
